import { Tag } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Test/Types/TestQuestion';
import { ContentType } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Types/CourseContent.types';
import { GroupPermissions } from '@Pages/Roles/Types/Roles.types';
import { Course, CourseUnit } from '@Services/classrooms/classrooms.res.types';

export type DropdownsState = {
	dropdownInstructors: Array<DropdownInstructor>;
	dropdownCategories: Array<DropdownCategory>;
	dropdownClassrooms: Array<DropdownClassroom>;
	dropdownCourses: Array<DropdownCourse>;
	dropdownBatches: Array<DropdownBatch>;
	dropdownWalletBatches: Array<DropdownBatch>;
	dropdownTags: Array<Tag>;
	dropdownStandaloneCourses: Array<DropdownProduct>;
	dropdownBundles: Array<DropdownProduct>;
	group_permissions: Array<GroupPermissions>;
	DropdownUnits: Array<DropdownUnit>;
	dropdownTestAttempts: Array<DropDownTestAttempts>;
};

export type DropdownInstructor = {
	id: number;
	first_name: string;
	last_name: string;
};

export type DropdownCategory = {
	id: number;
	name: string;
};

export type DropdownClassroom = {
	id: number;
	title: string;
	label: string;
	courses?: Array<Course>;
};

export type DropdownCourse = {
	id: number;
	name: string;
	code: string;
	units?: Array<CourseUnit>;
};

export type DropdownUnit = {
	id: number;
	course_id: number;
	name: string;
	url: string;
	type: string;
	active: boolean;
	progress_included?: boolean;
	created_at: string;
	updated_at: string;
	lms_id: string;
	type_id?: number;
	order?: number;
	add_to_sequence: boolean;
	current_course: boolean;
	unitType: {
		id: number;
		name: ContentType;
		icon: string;
	};
};

export type TestAttemptsPayload = {
	unitId: number | undefined;
	userId: number | undefined;
};

export type DropDownTestAttempts = {
	id: number;
	created_at: Date;
};

export type DropdownBatch = {
	batch: number;
};

/**
 * Standalone courses and bundles share a shape here: both are top-level,
 * instructor-owned, priced products a promocode can target.
 */
export type DropdownProduct = {
	id: number;
	title: string;
	label: string;
	code: string;
	price: number;
	instructor_id: number;
};

/**
 * "Title (label)". Unlike the admin app, every product here belongs to the
 * same owner, so no instructor suffix is needed; the bracketed label is the
 * handle staff actually search by.
 */
export const productOptionLabel = (product: {
	title: string;
	label?: string;
}): string =>
	product.label ? `${product.title} (${product.label})` : product.title;
